import React from 'react';
import { Table, Col, Row } from 'react-bootstrap';
import { formatPercent } from '../Helpers';

const Summary = ({ quarterInfo }) => {

  return (
    <Row>
      <Col md={12}>
        <Table bordered responsive id="dashboard-summary">
          <thead>
            <tr>
              <th></th>
              <th>SG</th>
              <th>SPX</th>
              <th>DIFF</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1st Quarter</td>
              <td>{ quarterInfo.SGqtr1 + '%' }</td>
              <td>{ quarterInfo.SPXqtr1 + '%' }</td>
              <td>{ formatPercent(quarterInfo.qtr1Diff) }</td>
            </tr>
            <tr>
              <td>2nd Quarter</td>
              <td>{ quarterInfo.SGqtr2 + '%' }</td>
              <td>{ quarterInfo.SPXqtr2 + '%' }</td>
              <td>{ formatPercent(quarterInfo.qtr2Diff) }</td>
            </tr>
            <tr>
              <td>3rd Quarter</td>
              <td>{ quarterInfo.SGqtr3 + '%' }</td>
              <td>{ quarterInfo.SPXqtr3 + '%' }</td>
              <td>{ formatPercent(quarterInfo.qtr3Diff) }</td>
            </tr>
            <tr>
              <td>4th Quarter</td>
              <td>{ quarterInfo.SGqtr4 + '%' }</td>
              <td>{ quarterInfo.SPXqtr4 + '%' }</td>
              <td>{ formatPercent(quarterInfo.qtr4Diff) }</td>
            </tr>
            <tr>
              <td>Return</td>
              <td>{ formatPercent(quarterInfo.SGTotal) }</td>
              <td>{ formatPercent(quarterInfo.SPXTotal) }</td>
              <td>{ formatPercent(quarterInfo.totalDiff) }</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  );
}

export default Summary;